import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const FlatButtonElement = withStyles({
  root: (attributes) => ({
    margin: '0.5rem auto',
    '&.MuiButton-root': {
      width: '100%',
      height: attributes.height,
      border: '1px solid ' + attributes.bordercolor,
      backgroundColor: attributes.backgroundcolor,
      color: attributes.textcolor,

      '&:hover': {
        backgroundColor: attributes.hoverbackgroundcolor,
        color: attributes.hovertextcolor,
      },
    },
    '&.MuiButton-containedSecondary': {
      border: '1px solid #0094f6',
    },
  }),
})(Button);

const FlatButton = (props) => {
  const attributes = { ...props };
  if (!attributes.variant) {
    attributes.variant = 'contained';
  }
  if (!attributes.color) {
    attributes.color = 'primary';
  }
  if (!attributes.backgroundcolor) {
    attributes.backgroundcolor = '#e0e0e0';
  }
  if (!attributes.hoverbackgroundcolor) {
    attributes.hoverbackgroundcolor = '#b2b2b2';
  }
  if (!attributes.textcolor) {
    attributes.textcolor = '#ffffff';
  }
  if (!attributes.hovertextcolor) {
    attributes.hovertextcolor = attributes.textcolor;
  }
  if (!attributes.bordercolor) {
    attributes.bordercolor = '#e6e6e6';
  }
  if (!attributes.height) {
    attributes.height = '56px';
  }
  const children = props.children;
  return (
    <FlatButtonElement disableElevation {...attributes}>
      {children}
    </FlatButtonElement>
  );
};

export default FlatButton;
